import { BodyText, Icon, Stack } from '@servicetitan/design-system';
import { tokens } from '@servicetitan/tokens/core';
import formatAddress from '@lib/utils/formatAddress';
import LinkoutButton from '@components/LinkoutButton/LinkoutButton';
import { Address } from '@api/generated/graphql';
import { inboxLocators } from '@locators/inbox';

interface LocationProps {
  address: Address;
  onLinkOutClicked?: () => void;
}

const Location = ({ address, onLinkOutClicked }: LocationProps) => {
  return (
    <Stack className='p-1' spacing={1} alignItems='center'>
      <Icon name='place' size={16} color={tokens.colorNeutral100} />
      <BodyText size='small'>{formatAddress(address)}</BodyText>
      {onLinkOutClicked && (
        <LinkoutButton
          id={inboxLocators.customerSearch.customerLocation}
          tooltipText='View Location'
          onClick={onLinkOutClicked}
        />
      )}
    </Stack>
  );
};

export default Location;
